import {AmplitudeOfferPromotionLocation} from "./get_amplitude_offer_promotion_event_properties";

export interface IAmplitudeOfferPromotionModalCloseTrackingParams {
    buttonCategory: AmplitudeOfferPromotionLocation;
    itemId: number;
    creativeName: string | string[];
    promotionId?: number | number[];
}

export const getAmplitudeOfferPromotionModalCloseEventProperties = (params: IAmplitudeOfferPromotionModalCloseTrackingParams) => ({
    button_name: "promotion_modal_close",
    button_category: params.buttonCategory,
    item_id: params.itemId,
    creative_name: params.creativeName,
    ...(params.promotionId != null && {promotion_id: params.promotionId})
});
import {AmplitudeOfferPromotionLocation} from "./get_amplitude_offer_promotion_event_properties";

export interface IAmplitudeOfferPromotionModalCloseTrackingParams {
    buttonCategory: AmplitudeOfferPromotionLocation;
    itemId: number;
    creativeName: string | string[];
    promotionId?: number | number[];
}

export const getAmplitudeOfferPromotionModalCloseEventProperties = (params: IAmplitudeOfferPromotionModalCloseTrackingParams) => ({
    button_name: "promotion_modal_close",
    button_category: params.buttonCategory,
    item_id: params.itemId,
    creative_name: params.creativeName,
    ...(params.promotionId != null && {promotion_id: params.promotionId})
});
